import React from 'react';
import { getText } from '../../utils/functions';
import FileInput from './FileInput';


function Attachments({
	portal,
	personType,
	formType,
	translate,
	formData,
	setFormData,
	colors,

	/* OPTIONAL PROPS */
	classNameATTACHMENTS = 'w-full flex mr-8 grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10',
}) {
	const [totalAttachmentsSize, setTotalAttachmentsSize] = React.useState(0);
	const [requiredAttachments, setRequiredAttachments] = React.useState();

	/* Get total attachment size */
	React.useEffect(
		() => setTotalAttachmentsSize(
			Object.values(formData?.attachments || {})?.reduce(
				(sum, att) => (att !== null ? sum + att.filesize : sum),
				0
			)
		),
		[formData?.attachments]
	);

	/* Get the dinamic required attachments */
	const getRequiredAttachments = React.useMemo(() => portal?.config?.requiredAttachments?.[formType]
		?.filter(fileInput => fileInput.personType === personType),
	[personType, portal?.config?.inputs?.[formType]]);

	React.useEffect(() => {
		setRequiredAttachments(getRequiredAttachments);
	}, [getRequiredAttachments]);

	/* onChange function */
	const onChange = (name, value, text) => setFormData({
		...formData,
		attachments: {
			...formData?.attachments,
			[name]: value === null ? value
				: {
					...value,
					text
				}
		}
	});

	return <div className={classNameATTACHMENTS}>
		{requiredAttachments?.map(fileInput => <FileInput
			// eslint-disable-next-line prefer-template
			label={'' + getText(portal?.config?.forms?.attach, translate) + ' ' + getText(fileInput, translate)}
			text={getText(fileInput, translate)}
			value={formData?.attachments?.[fileInput.name]}
			required={fileInput?.required}
			onChange={onChange}
			acceptedFileTypes={fileInput?.fileTypes}
			name={fileInput.name}
			key={fileInput.name}
			maxSize={portal?.config?.attachmentsMaxSize}
			totalAttachmentsSize={totalAttachmentsSize}
			colors={colors}
			translate={translate}
			portal={portal} />)
		}
	</div>;
}

export default Attachments;
